<script setup>
import { computed } from 'vue';

import WootLabel from 'dashboard/components-next/label/Label.vue';
import {
  BaseTable,
  BaseTableRow,
  BaseTableCell,
} from 'dashboard/components-next/table';

import { useAutomationOperationsFormatters } from './composables/useAutomationOperationsFormatters';

defineProps({
  signals: { type: Array, default: () => [] },
  isLoading: { type: Boolean, default: false },
});

const { t, formatStatus, labelColor } = useAutomationOperationsFormatters();

const signalHeaders = computed(() => [
  t('AUTOMATION.OPERATIONS.HEALTH.KEY'),
  t('AUTOMATION.OPERATIONS.HEALTH.GROUP'),
  t('AUTOMATION.OPERATIONS.HEALTH.SEVERITY'),
  t('AUTOMATION.OPERATIONS.HEALTH.OBSERVED'),
  t('AUTOMATION.OPERATIONS.HEALTH.RUNBOOK'),
]);
</script>

<template>
  <div class="min-w-0">
    <div class="mb-2 flex items-center justify-between gap-3">
      <span class="text-heading-3 text-n-slate-12">
        {{ $t('AUTOMATION.OPERATIONS.HEALTH.SIGNALS_TITLE') }}
      </span>
      <WootLabel
        :label="signals.length.toString()"
        :color="signals.length ? 'amber' : 'teal'"
        compact
      />
    </div>
    <BaseTable
      :headers="signalHeaders"
      :items="signals"
      :loading="isLoading"
      :loading-message="$t('AUTOMATION.OPERATIONS.HEALTH.LOADING')"
      :no-data-message="$t('AUTOMATION.OPERATIONS.HEALTH.NO_SIGNALS')"
    >
      <template #row="{ items }">
        <BaseTableRow
          v-for="signal in items"
          :key="signal.key"
          :item="signal"
          :state="signal.severity === 'critical' ? 'error' : 'warning'"
        >
          <template #default>
            <BaseTableCell>
              <span class="text-body-main text-n-slate-12 truncate">
                {{ signal.key }}
              </span>
            </BaseTableCell>
            <BaseTableCell>
              <span class="text-body-main text-n-slate-11">
                {{ signal.group }}
              </span>
            </BaseTableCell>
            <BaseTableCell>
              <WootLabel
                :label="formatStatus(signal.severity)"
                :color="labelColor(signal.severity)"
                compact
              />
            </BaseTableCell>
            <BaseTableCell>
              <span class="tabular-nums text-n-slate-12">
                {{ signal.observed }}
              </span>
            </BaseTableCell>
            <BaseTableCell>
              <span class="text-body-main text-n-slate-11">
                {{ signal.runbook_key }}
              </span>
            </BaseTableCell>
          </template>
        </BaseTableRow>
      </template>
    </BaseTable>
  </div>
</template>
